module.exports = __webpack_public_path__ + "static/media/pickSFX.0adab370.mp3";